import { deleteRequest, getRequest, postRequest, putRequest } from "lib/core/apiClient";
import { CheckoutPlansResult } from "lib/types/subscriptions";
import { parseCheckoutPlansResponse } from "lib/utils/subscriptions/parseSubscriptions";

export const fetchCheckoutPlans = async (checkoutId: string): Promise<CheckoutPlansResult> => {
  const response = await getRequest(`/checkout/${checkoutId}/plans`, "KRATOS_PRIVATE");
  return parseCheckoutPlansResponse(response);
};

export const subscribeCheckout = async (checkoutId: string, subscriptionId: string) =>
  postRequest(`/checkout/${checkoutId}/subscribe/${subscriptionId}`, {}, "KRATOS_PRIVATE");

export const selectCheckoutPlan = async (checkoutId: string, planId: string) =>
  putRequest(`/checkout/${checkoutId}/plans/${planId}`, {}, "KRATOS_PRIVATE");

export const clearCheckoutPlan = async (checkoutId: string) =>
  deleteRequest(`/checkout/${checkoutId}/plans`, undefined, "KRATOS_PRIVATE");
